// extracted by mini-css-extract-plugin
export var blocks = "SimplePage-module--blocks--boL5M";
export var container = "SimplePage-module--container--hh6vr";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var title = "SimplePage-module--title--QAc0H";